import { render, staticRenderFns } from "./MonthlyEPFAlliance.vue?vue&type=template&id=2641d7be"
import script from "./MonthlyEPFAlliance.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFAlliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports